export function convertServiceObjectFromServerToServiceObjectMinimal (serviceObjectType, serviceObjectFromServer) {
  const convertedServiceObject = {}

  convertedServiceObject.lastRequestReport = serviceObjectFromServer.lastRequestReport || null
  convertedServiceObject.lastRequestReportDocuments = serviceObjectFromServer.lastRequestReportDocuments || []
  convertedServiceObject.serviceObjectType = serviceObjectType
  convertedServiceObject.id = serviceObjectFromServer.id
  convertedServiceObject.key = serviceObjectFromServer.key
  convertedServiceObject.type = serviceObjectFromServer.type
  convertedServiceObject.gosContract = serviceObjectFromServer.gosContract
  convertedServiceObject.zabbixMonitoringStatus = serviceObjectFromServer.zabbixMonitoringStatus || null
  convertedServiceObject.zabbixMonitoringSwitchStatus = serviceObjectFromServer.zabbixMonitoringSwitchStatus || null

  // Название объекта.
  convertedServiceObject.name = 'Нет данных'
  if (serviceObjectFromServer.alias && serviceObjectFromServer.alias != '') {
    convertedServiceObject.name = serviceObjectFromServer.alias
  }

  // Адрес объекта.
  convertedServiceObject.addressSummary = 'Нет данных'
  if (serviceObjectFromServer.addressSummary && serviceObjectFromServer.addressSummary != '') {
    convertedServiceObject.addressSummary = serviceObjectFromServer.addressSummary
  }

  // Адрес объекта в Roads.
  convertedServiceObject.visAddress = 'Нет данных'
  if (serviceObjectFromServer.visAddress && serviceObjectFromServer.visAddress != '') {
    convertedServiceObject.visAddress = serviceObjectFromServer.visAddress
  }

  // Округ объекта.
  convertedServiceObject.district = 'Нет данных'
  if (serviceObjectFromServer.district && serviceObjectFromServer.district != '') {
    convertedServiceObject.district = serviceObjectFromServer.district
  }

  // Координаты объекта.
  convertedServiceObject.locationForLink = null
  if (serviceObjectFromServer.location && serviceObjectFromServer.location != '') {
    convertedServiceObject.locationForLink = serviceObjectFromServer.location.lon + ',' + serviceObjectFromServer.location.lat
  }

  convertedServiceObject.location = 'Нет данных'
  if (serviceObjectFromServer.location && serviceObjectFromServer.location != '') {
    convertedServiceObject.location = serviceObjectFromServer.location
  }

  // IP адрес объекта.
  convertedServiceObject.deviceIp = '0.0.0.0'
  if (serviceObjectFromServer.deviceIp && serviceObjectFromServer.deviceIp != '') {
    convertedServiceObject.deviceIp = serviceObjectFromServer.deviceIp
  }

  // Балансовый статус объекта
  convertedServiceObject.roadsBalancedStatusName = 'Нет данных'
  if (serviceObjectFromServer.roadsBalancedStatusName && serviceObjectFromServer.roadsBalancedStatusName != '') {
    convertedServiceObject.roadsBalancedStatusName = serviceObjectFromServer.roadsBalancedStatusName
  }

  // Статус объекта.
  convertedServiceObject.status = 'Нет данных'
  if (serviceObjectFromServer.status && serviceObjectFromServer.status != '') {
    convertedServiceObject.status = serviceObjectFromServer.status
  }

  // Статус объекта (СДП).
  convertedServiceObject.objectStatus = null
  if (serviceObjectFromServer.objectStatus && serviceObjectFromServer.objectStatus != '') {
    convertedServiceObject.objectStatus = serviceObjectFromServer.objectStatus
  }

  // Условие выезда.
  convertedServiceObject.checkoutStatus = null
  if (serviceObjectFromServer.checkoutStatus && serviceObjectFromServer.checkoutStatus != '') {
    convertedServiceObject.checkoutStatus = serviceObjectFromServer.checkoutStatus
  }

  // Условие выезда.
  convertedServiceObject.conductorConnectionStatus = null
  if (serviceObjectFromServer.conductorConnectionStatus && serviceObjectFromServer.conductorConnectionStatus != '') {
    convertedServiceObject.conductorConnectionStatus = serviceObjectFromServer.conductorConnectionStatus
  }

  // Ключ статуса объекта (СДП).
  convertedServiceObject.objectStatusCode = null
  if (serviceObjectFromServer.objectStatusCode && serviceObjectFromServer.objectStatusCode != '') {
    convertedServiceObject.objectStatusCode = serviceObjectFromServer.objectStatusCode
  }

  // Состояние объекта
  convertedServiceObject.objectCondition = null
  if (serviceObjectFromServer.objectCondition && serviceObjectFromServer.objectCondition != '') {
    convertedServiceObject.objectCondition = serviceObjectFromServer.objectCondition
  }

  // История изменения статуса объекта (СДП).
  convertedServiceObject.objectStatusHistory = null
  if (serviceObjectFromServer.objectStatusHistory && serviceObjectFromServer.objectStatusHistory != '') {
    convertedServiceObject.objectStatusHistory = serviceObjectFromServer.objectStatusHistory
  }

  // Недавние заявки
  if (serviceObjectFromServer.recentRequests && serviceObjectFromServer.recentRequests != '') {
    convertedServiceObject.recentRequests = serviceObjectFromServer.recentRequests
  }

  // Приоритет
  if (serviceObjectFromServer.priority && serviceObjectFromServer.priority != '') {
    convertedServiceObject.priority = serviceObjectFromServer.priority
  }

  // Дополнительный приоритет
  if (serviceObjectFromServer.subPriority && serviceObjectFromServer.subPriority != '') {
    convertedServiceObject.subPriority = serviceObjectFromServer.subPriority
  }

  // Комментарии
  if (serviceObjectFromServer.commonComment && serviceObjectFromServer.commonComment.length > 0) {
    convertedServiceObject.commonComment = serviceObjectFromServer.commonComment
  }

  // Проекты
  convertedServiceObject.projects = serviceObjectFromServer.projects || []

  // Светофорный объект.
  if (serviceObjectType == 'trafficLight' || serviceObjectType == 'transportDetector') {
    // Тип контроллера.
    convertedServiceObject.controllerType = 'Нет данных'
    if (serviceObjectFromServer.controllerType && serviceObjectFromServer.controllerType != '') {
      convertedServiceObject.controllerType = serviceObjectFromServer.controllerType
    }
  } else if (serviceObjectType == 'cameraFVF') { // Камера фото-видео фиксации.
    // Координаты рубежа.
    convertedServiceObject.frontierLocation = 'Нет данных'
    if (serviceObjectFromServer.frontierLocation && serviceObjectFromServer.frontierLocation != '') {
      convertedServiceObject.frontierLocation = serviceObjectFromServer.frontierLocation
    }
  } else if (serviceObjectType == 'cameraTV') { // Камера телеобзора.
    convertedServiceObject.cameraType = 'Нет данных'
    if (serviceObjectFromServer.cameraType && serviceObjectFromServer.cameraType != '') {
      convertedServiceObject.cameraType = serviceObjectFromServer.cameraType
    }
  } else if (serviceObjectType == 'TOI') { // Табло отображения информации.
    // EMPTY.
  } else if (serviceObjectType == 'transportDetector') { // Детектор траспорта.
    // Тип датчика.
    convertedServiceObject.detectorType = 'Нет данных'
    if (serviceObjectFromServer.equipmentTypes && serviceObjectFromServer.equipmentTypes != '') {
      if (serviceObjectFromServer.equipmentTypes.length != 0) {
        convertedServiceObject.detectorType = serviceObjectFromServer.equipmentTypes[0].name
      }
    }
  }

  return convertedServiceObject
}
